<template>
  <div>
    <div class="contactUs">
      <div class="text">
        客户服务
      </div>
      <div class="border_"></div>
      <div class="title">
        我们随时准备为您提供帮助，请通过以下方式与我们
      </div>
      <div class="card_list">
        <div class="card_info" @click="makeCall">
          <div class="image"><img src="/status/dianhua.png"></div>
          <div>
            <div class="text_y">联系电话</div>
            <div class="text_x">400-022-9558</div>
          </div>
        </div>
        <div class="card_info">
          <div class="image"><img src="/status/dinwgei.png"></div>
          <div>
            <div class="text_y">官方网址</div>
            <div class="text_x">www.yuetaixing.com</div>
          </div>
        </div>
        <div class="card_info">
          <div class="image">
            <img src="/status/dinwgei.png">
          </div>
          <div>
            <div class="text_y">地址信息</div>
            <div class="text_x">长沙市雨花区金海路158号</div>
          </div>
        </div>
        <div class="card_info">
          <div class="image">
            <img src="/status/aite.png">
          </div>
          <div>
            <div class="text_y">官方邮箱</div>
            <div class="text_x">www.yuetaixing188@163.com</div>
          </div>
        </div>



      </div>
    </div>
    <div class="dibu">
      <div class="dibu_left">
        <div class="text">
          免费获取解决方案
        </div>
        <div class="border_"></div>
        <div class="title">
          预约销售顾问，与您面对面沟通
        </div>
        <div class="image">
          <img src="/status/lianxiwomen.png">
        </div>
        <div class="zxlx">长按图片保存联系</div>
      </div>
      <div class="dibu_right">
        <div class="text">
          业务合作
        </div>
        <div class="border_"></div>
        <div class="image">
          <img src="/status/lianxiwomen.png">
        </div>
      </div>
    </div>
    <tail_menu></tail_menu>
  </div>
</template>

<script>
import tail_menu from "@/components/tail_menu_phone";
export default {
  name: "contactUs",
  components:{
    tail_menu,
  },
  data(){
    return{
      phoneNumber:'400-022-9558'
    }
  },
  methods:{
    makeCall() {
      window.location.href = `tel:${this.phoneNumber}`;
    },
  }
}
</script>

<style scoped lang="scss">
.contactUs{
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 50px 0;
  .text{
    font-size: 74px;
    font-weight: 600;
    color: #003b76;
  }
  .border_{
    margin-top: 30px;
    width: 250px;
    border: 2px solid #327ecb;
  }
  .title{
    margin-top: 30px;
    color: #15191d;
    opacity: 0.73;
    font-size: 54px;
  }
  .card_list{
    display: flex;
    margin-top: 50px;
    flex-wrap: wrap;
    width: 1240px;
    justify-content: space-between;
    .card_info{
      //background: rgb(222,237,248);
      border-radius: 8px;
      padding: 12px 0 12px 20px;
      width: 45%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      margin-top: 30px;
      .image{
        background: white;
        border-radius: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100px;
        img{
          width: 124px;
        }
      }

      .text_y{
        color: #4a7bac;
        font-size: 60px;
        text-align: center;
        margin-top: 30px;
      }
      .text_x{
        color: #4a7bac;
        font-size: 40px;
        margin-top: 30px;
      }
    }
  }
}
.dibu{
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 80px 0;
  background: rgb(222,237,248);
  .dibu_left{
    display: flex;
    align-items: center;
    flex-direction: column;
    border-radius: 8px;
    background: white;
    padding: 30px;
    width: 600px;
    height: 650px;
    .text{
      font-size: 52px;
      font-weight: bold;
      color: #003b76;
    }
    .border_{
      margin-top: 10px;
      width: 150px;
      border: 1px solid #327ecb;
    }
    .title{
      margin-top: 30px;
      color: #15191d;
      opacity: 0.73;
      font-size: 36px;
    }
    .image{
      img{
        margin-top: 30px;
        width: 340px;
      }
    }
    .zxlx{
      background: black;
      color: white;
      margin-top: 20px;
      font-size: 34px;
      padding: 10px 30px;
    }
  }
  .dibu_right{
    margin-right: 15px;
    display: flex;
    align-items: center;
    flex-direction: column;
    border-radius: 8px;
    background: white;
    padding: 30px;
    width: 600px;
    height: 650px;
    margin-left: 110px;
    .text{
      font-size: 52px;
      font-weight: bold;
      color: #003b76;
    }
    .border_{
      margin-top: 10px;
      width: 150px;
      border: 1px solid #327ecb;
    }
    .image{
      img{
        margin-top: 44px;
        width: 500px;
      }
    }
  }
}
</style>
